<template>
  <div>
    <div class="d-flex justify-space-between align-center pa-4 pa-md-2">
      <div>
        <Breadcrumbs
          headline="Nhân viên"
          :link="[{ text: 'Nhân viên', disabled: true, href: '/managers' }]"
        />
      </div>
    </div>

    <v-card class="pa-2 pa-md-2 mx-md-2">
      <v-data-table
        @click:row="onRowClick"
        item-key="id"
        :headers="headers"
        :items="items"
        :search="search"
        :loading="isLoading"
        :disable-pagination="true"
        hide-default-footer
        dense
      >
        <template v-slot:item.managerType="{ item }">
          {{ getManagerTypeLabel(item.managerType) }}
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="d-flex">
            <v-btn small icon @click.stop="toggleBlock(item)">
              <v-icon>{{ item.user.status === 'blocked' ? 'mdi-lock-open' : 'mdi-lock' }}</v-icon>
            </v-btn>
            <v-btn small icon @click.stop="onClickSwap(item)">
              <v-icon>mdi-swap-horizontal</v-icon>
            </v-btn>
          </div>
        </template>
        <template v-slot:top>
          <div class="d-flex align-center pa-2">
            <div>Total: {{ items.length }}</div>
            <div class="flex-fill"></div>
            <v-text-field
              class="text-field flex-grow-0 mr-2"
              dense
              hide-details="auto"
              prepend-inner-icon="mdi-magnify"
              v-model="search"
              outlined
              type="search"
            ></v-text-field>
            <v-select
              dense
              outlined
              v-model="managerType"
              :items="mangerTypeList"
              item-text="text"
              item-value="value"
              class="select-manager-type flex-grow-0 mr-2"
              hide-details="auto"
              label="Loại nhân viên"
            ></v-select>
            <v-btn elevation="0" color="primary" @click="onClickAddManager"> Thêm </v-btn>
          </div>
        </template>

        <template v-slot:[`item.name`]="{ item }">
          <user-item :data="item"></user-item>
        </template>

        <template v-slot:[`item.role.name`]="{ item }">
          <div class="staff-department">{{ item.department.title }}</div>
        </template>

        <template v-slot:[`item.user.status`]="{ item }">
          <v-chip v-if="!item.user.blocked" small label color="success" dark>{{
            'Hoạt động'
          }}</v-chip>
          <v-chip v-else small label color="error" dark>{{ 'Đã khóa' }}</v-chip>
        </template>
      </v-data-table>
    </v-card>
    <BaseDialog
      v-if="swapDialog.isOpen"
      :isOpen="swapDialog.isOpen"
      @close="swapDialog.isOpen = false"
      @cancel="swapDialog.onCancel"
      @confirm="swapDialog.callback"
      :title="swapDialog.title"
    >
      <v-form lazy-validation ref="swapDialog">
        <v-card-text>
          <p>Người dùng: {{ swapDialog.currentItem.item.name }}</p>
          <p>
            Vai trò hiện tại: {{ getManagerTypeLabel(swapDialog.currentItem.item.managerType) }}
          </p>
          <v-select
            label="Vai trò mới"
            v-model="swapDialog.currentItem.new_type"
            :items="
              mangerTypeList.filter(
                i => i.value && i.value !== swapDialog.currentItem.item.managerType
              )
            "
          ></v-select> </v-card-text
      ></v-form>
    </BaseDialog>
    <BaseDialog
      v-if="createDialog.isOpen"
      :isOpen="createDialog.isOpen"
      @close="createDialog.isOpen = false"
      @cancel="createDialog.onCancel"
      @confirm="createDialog.callback"
      :title="createDialog.title"
    >
      <v-form lazy-validation ref="createDialog">
        <v-card-text>
          <v-text-field
            :rules="[$rules.required]"
            v-model="createDialog.currentItem.name"
            label="Họ và Tên"
            outlined
            dense
          ></v-text-field>
          <v-select
            dense
            outlined
            v-model="createDialog.currentItem.managerType"
            :items="mangerTypeList.filter(i => i.value)"
            item-text="text"
            item-value="value"
            label="Loại nhân viên"
          ></v-select>

          <v-text-field
            dense
            outlined
            :rules="[$rules.required]"
            v-model="createDialog.currentItem.phone"
            label="Số điện thoại"
          ></v-text-field>
          <v-text-field
            v-model="createDialog.currentItem.user.email"
            label="Email"
            :error-messages="emailError"
            validate-on-blur
            outlined
            dense
            :rules="[$rules.required, $rules.email]"
          ></v-text-field>
          <v-text-field
            v-model="createDialog.currentItem.user.password"
            label="Mật Khẩu"
            :append-icon="createDialog.showPassword ? 'visibility' : 'visibility_off'"
            :rules="[$rules.required, $rules.min]"
            :type="createDialog.showPassword ? 'text' : 'password'"
            @click:append="createDialog.showPassword = !createDialog.showPassword"
            hint="At least 6 characters"
            outlined
            dense
          ></v-text-field>
        </v-card-text>
      </v-form>
    </BaseDialog>
  </div>
</template>
<script>
import BaseDialog from '@/components/base/BaseDialog'

import Breadcrumbs from '@/components/layout/Breadcrumbs'
import UserItem from '@/modules/user/UserItem'
import { mapActions, mapState } from 'vuex'
import { getStatusColor, getManagerTypeLabel } from '@/helpers'
import { get, cloneDeep } from 'lodash'
import { getStatusLabel } from '../../helpers'
const originHeaders = [
  { text: 'Tên', value: 'name', align: 'left', sortable: false, show: true },
  { text: 'Mã nhân viên', value: 'code', align: 'left', sortable: false, show: true },
  { text: 'Email', value: 'email', align: 'left', sortable: false, show: true },
  {
    text: 'Số Điện Thoại',
    value: 'phone',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Trạng Thái',
    value: 'status',
    align: 'left',
    sortable: false,
    show: true
  },
  { text: 'Hành động', value: 'actions', show: true, sortable: false }
]

export default {
  components: {
    UserItem,
    Breadcrumbs,
    BaseDialog
  },
  data() {
    return {
      managerType: get(this.$route.query, 'type', ''),
      createDialog: {
        currentItem: null,
        isOpen: false,
        title: '',
        valid: true,
        onCancel: () => {
          this.createDialog.isOpen = false
        },
        callback: () => {},
        showPassword: false
      },
      swapDialog: {
        currentItem: null,
        isOpen: false,
        title: '',
        valid: true,
        onCancel: () => {
          this.createDialog.isOpen = false
        },
        callback: () => {},
        showPassword: false
      },
      headers: [
        {
          text: 'STT',
          align: 'left',
          sortable: false,
          value: 'index'
        },
        {
          text: 'Họ và tên',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        {
          text: 'Vai trò',
          align: 'left',
          sortable: false,
          value: 'managerType'
        },
        {
          text: 'Mã NV',
          align: 'left',
          sortable: false,
          value: 'user.username'
        },
        {
          text: 'Email',
          align: 'left',
          sortable: false,
          value: 'user.email'
        },
        {
          text: 'SĐT',
          align: 'left',
          sortable: false,
          value: 'phone'
        },
        {
          text: 'SĐT',
          align: 'left',
          sortable: false,
          value: 'phone'
        },
        {
          text: 'Trạng thái',
          value: 'user.status',
          align: 'center',
          sortable: false,
          show: true
        },
        {
          text: 'Hành động',
          align: 'left',
          sortable: false,
          value: 'actions'
        }
      ],
      originHeaders: originHeaders,
      draw: false,
      search: '',
      status: null,
      range: { from: null, to: null },
      previewUserId: null,
      ready: false,
      isLoading: false,
      createState: false,
      chipLabel: ''
    }
  },
  async created() {
    this.isLoading = true
    try {
      await Promise.all([
        this.fetchAccountants({ _limit: -1 }),
        this.fetchEducationManagers({ _limit: -1 }),
        this.fetchManagers({ _limit: -1 }),
        this.fetchSuperAdmins({ _limit: -1 })
      ])
    } catch (error) {
      console.error(error)
    } finally {
      this.isLoading = false
    }
  },
  computed: {
    ...mapState('accountant', ['accountants']),
    ...mapState('manager', ['managers']),
    ...mapState('education_manager', ['educationManagers']),
    ...mapState('super_admin', ['superAdmins']),
    ...mapState('app', ['department']),
    ...mapState('auth', ['user', 'role']),
    mangerTypeList() {
      return [
        { text: 'Tất cả', value: '' },
        { text: 'Nhân viên', value: 'manager' },
        { text: 'Quản lý đào tạo', value: 'education_manager' },
        { text: 'Quản lý cao cấp', value: 'super_admin' },
        { text: 'Kế toán', value: 'accountant' }
      ]
    },
    items() {
      const educationManagers = this.educationManagers.map(i => ({
        ...i,
        managerType: 'education_manager'
      }))

      const accountants = this.accountants.map(i => ({ ...i, managerType: 'accountant' }))
      const managers = this.managers.map(i => ({ ...i, managerType: 'manager' }))
      const superAdmins = this.superAdmins.map(i => ({ ...i, managerType: 'super_admin' }))
      let output
      switch (this.managerType) {
        case 'education_manager':
          output = educationManagers
          break
        case 'accountant':
          output = accountants
          break
        case 'manager':
          output = managers
          break
        case 'super_admin':
          output = superAdmins
          break

        default:
          output = accountants.concat(educationManagers).concat(managers).concat(superAdmins)
      }

      return output.map((i, index) => ({ ...i, index: index + 1 }))
    }
  },
  methods: {
    ...mapActions('accountant', ['fetchAccountants', 'createAccountant', 'swapAccountant']),
    ...mapActions('manager', ['fetchManagers', 'createManager', 'swapManager']),
    ...mapActions('super_admin', ['fetchSuperAdmins', 'createSuperAdmin', 'swapSuperAdmin']),
    ...mapActions('education_manager', [
      'fetchEducationManagers',
      'createEducationManager',
      'swapEducationManager'
    ]),
    ...mapActions('user', ['updateUser']),
    ...getStatusColor,
    getStatusLabel,
    getManagerTypeLabel,
    async toggleBlock(item) {
      const isCurrentUserBlocked = item.user.blocked
      const done = async () => {
        const payload = {
          status: item.user.status === 'blocked' ? 'active' : 'blocked',
          blocked: !item.user.blocked
        }
        await this.updateUser({ id: item.user.id, ...payload })
        this.$alert('Cập nhật thành công')
      }
      if (isCurrentUserBlocked) {
        await done()
      } else {
        this.$dialog.confirm({
          title: 'Dừng hoạt động người dùng',
          text: 'Người dùng này sẽ không thể đăng nhập được nữa, bạn có chắc chắn muốn tiếp tục',
          okText: 'Xác nhận',
          cancelText: 'Hủy',
          done: () => {
            done()
          }
        })
      }
    },
    onClickSwap(item) {
      this.swapDialog.isOpen = true
      this.swapDialog.title = `Thay đổi vai trò quản lý`
      this.swapDialog.currentItem = {
        item,
        new_type: ''
      }
      this.swapDialog.valid = true
      this.swapDialog.callback = (async () => {
        const isValid = this.$refs.swapDialog.validate()
        if (!isValid) {
          return
        }
        switch (this.swapDialog.currentItem.item.managerType) {
          case 'accountant':
            await this.swapAccountant({
              id: item.id,
              params: {
                type: this.swapDialog.currentItem.new_type
              }
            })
            break
          case 'education_manager':
            await this.swapEducationManager({
              id: item.id,
              params: {
                type: this.swapDialog.currentItem.new_type
              }
            })
            break
          case 'super_admin':
            await this.swapSuperAdmin({
              id: item.id,
              params: {
                type: this.swapDialog.currentItem.new_type
              }
            })
            break

          default:
            await this.swapManager({
              id: item.id,
              params: {
                type: this.swapDialog.currentItem.new_type
              }
            })
            break
        }

        this.$alert.success('Cập nhật thành công')
        switch (this.swapDialog.currentItem.new_type) {
          case 'accountant':
            this.fetchAccountants({ _limit: -1 })
            break
          case 'education_manager':
            this.fetchEducationManagers({ _limit: -1 })
            break
          case 'super_admin':
            this.fetchSuperAdmins({ _limit: -1 })
            break

          default:
            this.fetchManagers({ _limit: -1 })
            break
        }
        this.swapDialog.isOpen = false
      }).bind(this)
    },
    onClickAddManager() {
      this.createDialog.isOpen = true
      this.createDialog.title = `Tạo nhân viên`
      this.createDialog.currentItem = {
        user: {
          department: this.department.id
        },
        managerType: 'manager'
      }
      this.createDialog.valid = true
      this.createDialog.callback = (async () => {
        const isValid = this.$refs.createDialog.validate()
        if (!isValid) {
          return
        }
        const payload = cloneDeep(this.createDialog.currentItem)

        delete payload.managerType
        switch (this.createDialog.currentItem.managerType) {
          case 'accountant':
            await this.createAccountant({
              params: payload
            })
            break
          case 'education_manager':
            await this.createEducationManager({
              params: payload
            })
            break
          case 'super_admin':
            await this.createSuperAdmin({
              params: payload
            })
            break

          default:
            await this.createManager({
              params: payload
            })
            break
        }

        this.$alert.success('Tạo thành công')
        this.createDialog.isOpen = false
      }).bind(this)
    },
    onRowClick(item) {
      switch (item.managerType) {
        case 'accountant':
          this.$router.push(`manager/accountant/${item.id}`)
          break

        case 'education_manager':
          this.$router.push(`manager/education-manager/${item.id}`)
          break
        case 'super_admin':
          this.$router.push(`manager/super-admin/${item.id}`)
          break

        case 'manager':
          this.$router.push(`manager/staff/${item.id}`)
          break

        default:
          break
      }
    },
    updateDraw(draw) {
      this.draw = draw
    },
    async preview(user) {
      if (!user) return
      this.$refs.template.preview()
      this.previewUserId = user.id
    },
    filterItems(value, search) {
      let regex = new RegExp(search.replace(/\s+/g, ' ').trim(), 'i')
      if (value.name.match(regex)) {
        return true
      }
      if (value.email.match(regex)) {
        return true
      }
      if (value.phone.match(regex)) {
        return true
      }
      return false
    }

    // }
  }
}
</script>

<style scoped>
.text-field {
  width: 240px;
}
.select-manager-type {
  width: 160px;
  padding-top: 0;
  margin-top: 0;
}
</style>
